import { render } from "./EditEvaluation.vue?vue&type=template&id=7896c6f1"
import script from "./EditEvaluation.vue?vue&type=script&lang=js"
export * from "./EditEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__